export default __webpack_public_path__ + "514c077a2feca031612b5446115b29e7.mp3";